/**
 * See also Cookies.kt in webshop-frontend
 */
export const Cookies = {
  isMatomoTrackingAllowed: 'isMatomoTrackingAllowed',
  isGoogleAnalyticsAllowed: 'isGoogleAnalyticsAllowed'
};
